/**
 * Буквенный аватар: инициалы по общему алгоритму (`design/components/initials.json`).
 *
 * Появился после находки на живом продукте: «ООО «Кубик» · партнёр» давало аватар «О«» — первую
 * букву и кавычку. Первые символы первых слов — не инициалы: в названиях компаний первым символом
 * бывает кавычка, организационная форма занимает место значимого слова, а «IT-поддержка» без разбора
 * дефиса даёт одну букву.
 *
 * Алгоритм и корпус описаны у Дизайна и берутся отсюда данными: веб, десктоп и мобильные обязаны
 * рисовать одинаковые кружки для одного и того же чата.
 */
import rules from "../../design/components/initials.json" with { type: "json" };

/** Не буква, не цифра и не разделитель — кавычки, скобки, точки, «·», эмодзи. */
const noise = /[^\p{L}\p{N}\s-]/gu;
const skip = new Set(rules.skip.map((word) => word.toUpperCase()));

export function initials(title: string): string {
  // Адрес вместо имени: домен к человеку отношения не имеет, иначе «ivan@company.ru» даёт «IC».
  const at = title.indexOf("@");
  const source = at > 0 ? title.slice(0, at) : title;
  const words = source.replace(noise, " ").split(/[\s-]+/u).filter((word) => word !== "");
  // Организационную форму выбрасываем, только если после неё что-то остаётся: «ООО» — тоже название.
  const significant = words.filter((word) => !skip.has(word.toUpperCase()));
  const chosen = significant.length > 0 ? significant : words;
  const first = chosen[0];
  if (first === undefined) {
    return rules.fallback;
  }
  const letters = chosen.length > 1
    ? [...first].slice(0, 1).concat([...(chosen[1] ?? "")].slice(0, 1))
    : [...first].slice(0, rules.max_chars);
  return letters.join("").toUpperCase();
}
